import Vue from 'vue'
import messagesCs from 'vee-validate/dist/locale/cs'
import VeeValidate from 'vee-validate'
import VueDebounce from 'vue-debounce'
import moment from 'moment'
import 'moment/locale/cs'
import 'moment/locale/sk'
import 'moment/locale/en-gb'
import 'moment/locale/de'
import App from './App.vue'
import router from './router'
import store from './store'
import './auth'
import './filters'
import './globalComponents'
import attributesCs from './validation/attributesCs'

// import 'reset-css'
import './assets/css/style.css'

import GetTextPlugin from 'vue-gettext'
import translations from '../resources/translations.json'

Vue.use(GetTextPlugin, {
  availableLanguages: {
    CS: 'ces',
    SK: 'slk',
    EN: 'eng',
    DE: 'deu'
  },
  defaultLanguage: 'ces',
  translations: translations,
  silent: true
})

Vue.filter('translate', value => {
  return !value
    ? ''
    : Vue.prototype.$gettext(value.toString())
})

Vue.use(VeeValidate, {
  locale: 'cs',
  dictionary: {
    cs: { messages: messagesCs.messages, attributes: attributesCs }
  }
})

Vue.use(VueDebounce)

Vue.config.productionTip = false

App.router = router

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
